import {
  type RouteMatcher,
  tenantFromPathname,
} from "#/modules/util.fetch-client/tenant-from-pathname";

/**
 * The browser's router instance, registered by `getRouter()` under a structural type so the
 * tenant middleware can read the (possibly pending) location without importing the router's own
 * types — those derive from the route tree, which imports the middleware.
 */
type ClientRouterLike = RouteMatcher & { state: { location: { pathname: string } } };

let clientRouter: ClientRouterLike | null = null;

export function registerClientRouter(router: ClientRouterLike) {
  clientRouter = router;
}

/** During a pending navigation the router already points at the destination URL. */
export function getClientRouterPathname(): string | undefined {
  return clientRouter?.state.location.pathname;
}

/**
 * Whether preloading a school page would fetch with another tenant than its own. A preload leaves
 * the router where it is, and the tenant middleware sends that location, so another school's or
 * schooljaar's loaders would run with this page's tenant, or none, and cache the result as theirs.
 */
export function isPreloadForOtherTenant(tenant: { school: string; schoolyear?: string }): boolean {
  if (!clientRouter) return false;
  const current = tenantFromPathname(clientRouter, clientRouter.state.location.pathname);
  return current.school !== tenant.school || current.schoolyear !== tenant.schoolyear;
}
